<!-- Pipeline Expiring Contracts Section -->
<template>
  <base-expiring-contracts
    section-id="pipeline-expiring-contracts-section"
    base-class="pipeline-expiring-contracts-section"
    title="Contracts Expiring Soon"
    subtitle="From your tracked pipelines"
    header-icon="mdi-clock-outline"
    empty-message="No expiring contracts found in your pipelines"
    action-button-text="Remove from Pipeline"
    action-button-icon="mdi-bookmark-minus-outline"
    action-event-name="remove-from-pipeline"
    :contracts="contracts"
    :is-loading="isLoading"
    :section-style="sectionStyle"
    :is-visible="isVisible"
    :items-per-page="itemsPerPage"
    :show-story="true"
    :story-builder="buildContractStory"
    @remove-from-pipeline="contract => $emit('remove-from-pipeline', contract)"
  >
    <!-- Chips: pipeline group, competitor flag, timeframe -->
    <template #chips="{ contract, getTimeframeChip, setTimeframeFromContract }">
      <v-chip
        x-small
        class="contract-chip contract-chip-group"
        style="cursor: pointer;"
        @click="openPipelineTab(contract)"
      >
        <v-icon small left>mdi-bookmark</v-icon>
        {{ contract.group_name }}
      </v-chip>

      <v-chip
        v-if="contract.is_competitor"
        x-small
        class="contract-chip contract-chip-competitor"
      >
        <v-icon x-small left class="contract-chip-icon">mdi-alert</v-icon>
        COMPETITOR HELD
      </v-chip>

      <!-- Timeframe chip: click filters by this timeframe -->
      <template v-if="getTimeframeChip && setTimeframeFromContract">
        <v-chip
          v-if="getTimeframeChip(contract)"
          x-small
          :class="`contract-chip ${getTimeframeChip(contract).class}`"
          style="cursor: pointer;"
          @click.stop.prevent="setTimeframeFromContract(contract)"
        >
          <v-icon x-small left class="contract-chip-icon">{{ getTimeframeChip(contract).icon }}</v-icon>
          {{ getTimeframeChip(contract).label }}
        </v-chip>
      </template>
    </template>
  </base-expiring-contracts>
</template>

<script>
import BaseExpiringContracts from './BaseExpiringContracts.vue';
import { buildBaseContractStories } from './BaseExpiringContracts.vue';

export default {
  name: 'PipelineExpiringContractsSection',

  components: {
    BaseExpiringContracts
  },

  props: {
    contracts: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    sectionStyle: {
      type: String,
      default: ''
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },

  methods: {
    openPipelineTab(contract) {
      const groupId = contract && contract.group_id;
      if (!groupId) return;

      // Open Pipelines page in a new tab with the clicked pipeline group selected.
      const routeData = this.$router.resolve({
        name: 'pipelines',
        query: { group_id: groupId }
      });
      window.open(routeData.href, '_blank');
    },

    /**
     * Custom story builder for pipeline contracts that includes competitor information.
     * Extends the base story builder with competitor-specific details.
     */
    buildContractStory(contract, formatCurrency) {
      // Build base stories using the shared utility function
      const stories = buildBaseContractStories(contract, formatCurrency);

      // Pipeline-specific: include competitor information
      if (contract.is_competitor) {
        stories.push('currently held by a tracked competitor');
      }

      return stories.length > 0 ? `This is a ${stories.join(', ')}.` : '';
    }
  }
};
</script>

<!-- No scoped styles; styles from BaseExpiringContracts -->
